import React from 'react';
import { PropTypes } from 'prop-types';
import { Box, Button, Grid } from '@mui/material';

const EndUserSharedProgrammeRestartScreen = ({
  sharedProgrammeTitle,
  completionPercentage,
  onNext,
  onBack,
}) => {
  return (
    <div className="app-wizard">
      <div className="app-wizard-title">{sharedProgrammeTitle}</div>
      <div className="app-wizard-step">
        <div className="step-heading">
          <div className="completion-percentage">
            {completionPercentage}% complete
          </div>
          <div className="step-title">Restart current program?</div>
        </div>
        <div
          className="step-content light-background"
          style={{ marginTop: '50px' }}>
          <p>
            You are about to restart the program{' '}
            <strong>{sharedProgrammeTitle}</strong>
          </p>
        </div>
        <Grid container className="wizard-buttons">
          <Grid item xs={4}>
            {onBack && (
              <Button
                color="secondary"
                onClick={onBack}
                variant="contained"
                size="medium"
                disableElevation
                style={{ borderRadius: '30px', width: '90px' }}>
                Back
              </Button>
            )}
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" justifyContent="flex-end">
              <Button
                color="primary"
                onClick={onNext}
                variant="contained"
                size="medium"
                disableElevation
                style={{ borderRadius: '30px', width: '180px' }}>
                Restart program
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

EndUserSharedProgrammeRestartScreen.propTypes = {
  sharedProgrammeTitle: PropTypes.string.isRequired,
  completionPercentage: PropTypes.number.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default EndUserSharedProgrammeRestartScreen;
